module.exports = __webpack_public_path__ + "static/media/Team_MitarbeiterBlau.e751ce35.webp";